import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';

const Blocked = () => {
  const { handleShowUser, owner } = useLandingContext();

  return (
    <>
      <Box font="h4-semibold" mb={3}>
        {I18n.t('web.hide_user_publications.success_message', {
          username: owner?.name,
        })}
      </Box>
      <Button onClick={handleShowUser}>{__('Cancel')}</Button>
    </>
  );
};

export default Blocked;
